import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import { useScrollTrigger } from '@/hooks/useScrollTrigger';

// 第四屏：爱学AI致力于专业的AI教育技术
export default function Screen4() {
  const navigate = useNavigate();
  const rootRef = useScrollTrigger({
    triggerClass: styles['screen4-anim-start'],
    triggerRatio: 0.5,
    scrollContainerSelector: '.aixue-home-scroll',
    enableResizeDetection: true
  });

  // 仅负责回到产品中心顶部
  const scrollToProductTop = useCallback(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const node = document.querySelector(
          '[data-scroll-root="aixue-phonics"]',
        ) as HTMLElement | null;
        if (node) node.scrollTo({ top: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        window.scrollTo({ top: 0, behavior: 'auto' });
      });
    });
  }, []);

  return (
    <section className={styles['screen4-cover']} ref={rootRef}>
      <div className={styles['screen4-wrap']}>
        {/* 标题 */}
        <div className={styles['screen4-title-wrap']}>
          <h2 className={styles['screen4-title']}>AI教育产品</h2>
          <p className={styles['screen4-sub']}>
            爱学致力于利用AI技术，为用户提供专业、个性化、高质量的学习产品
          </p>
        </div>

        <div className={styles['screen4-content-wrap']}>
          <div className={styles['screen4-content']}>
            <div className={styles['screen4-content-title-eng']}></div>
            <div className={styles['screen4-content-title']}>爱学AI自然拼读</div>
            <div className={styles['screen4-content-sub']}>开口说英语，AI实时纠音</div>
            <div
              className={styles['screen4-content-btn']}
              onClick={() => {
                navigate('/aixue-phonics');
                scrollToProductTop();
              }}
            >
              <span>了解详情</span>
            </div>
          </div>
          <div className={styles['screen4-show-img']}></div>
        </div>
      </div>
    </section>
  );
}
